import "./filterfrequency.css";
import { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import { FormattedMessage } from "react-intl";
import "react-datepicker/dist/react-datepicker.css";
import TimeRangePopover from "../Home/Widgets/TimeRangePopover";

const FrequencyComponent = ({
  onValuesChange,
  startDate: pStartDate,
  endDate: pEndDate,
  frec: pFrec,

  showTimeRange = false,
  hourFrom,
  hourTo,
  draftHourFrom,
  draftHourTo,
  onApplyTimeRange,
  onDraftTimeRange,

  isAnalysis = false,
  isMaximeter = false
}) => {
  const [frec, setFrec] = useState(pFrec ?? "");
  const [startDate, setStartDate] = useState(pStartDate ?? null);
  const [endDate, setEndDate] = useState(pEndDate ?? null);

  useEffect(() => {
    setFrec(pFrec ?? "");
    setStartDate(pStartDate ?? null);
    setEndDate(pEndDate ?? null);
  }, [pFrec, pStartDate, pEndDate]);

  const handleFrec = (e) => {
    const value = e.target.value;
    setFrec(value);
    onValuesChange(value, startDate, endDate);
  };

  const onChange = (dates) => {
    let [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    onValuesChange(frec, start, end);
  };

  return (
    <div className="cont-graph">
      <div className="row-controls">
        <div className="group">
          <div className="label">
            <b>
              <FormattedMessage id="Date" defaultMessage="Date" />
            </b>
          </div>
          <div className="datepicker">
            <DatePicker
              dateFormat="yyyy/MM/dd"
              selected={startDate}
              onChange={onChange}
              startDate={startDate}
              endDate={endDate}
              selectsRange
            />
          </div>
        </div>

        {(!isAnalysis && !isMaximeter) && (<div className="group">
          <div className="label">
            <b>
              <FormattedMessage id="Frequency" defaultMessage="Frequency" />
            </b>
          </div>
          <div className="btn-group">
            <input
              type="radio"
              className="btn-check"
              value="15min"
              name="btnradio"
              id="btnradio1"
              autoComplete="off"
              onChange={handleFrec}
              checked={frec === "15min"}
            />
            <label className="btn-frec" htmlFor="btnradio1">
              15min
            </label>

            <input
              type="radio"
              className="btn-check"
              value="30min"
              name="btnradio"
              id="btnradio2"
              autoComplete="off"
              onChange={handleFrec}
              checked={frec === "30min"}
            />
            <label className="btn-frec" htmlFor="btnradio2">
              30min
            </label>

            <input
              type="radio"
              className="btn-check"
              value="hour"
              name="btnradio"
              id="btnradio3"
              autoComplete="off"
              onChange={handleFrec}
              checked={frec === "hour"}
            />
            <label className="btn-frec" htmlFor="btnradio3">
              hora
            </label>

            <input
              type="radio"
              className="btn-check"
              value="day"
              name="btnradio"
              id="btnradio4"
              autoComplete="off"
              onChange={handleFrec}
              checked={frec === "day"}
            />
            <label className="btn-frec" htmlFor="btnradio4">
              día
            </label>

            <input
              type="radio"
              className="btn-check"
              value="month"
              name="btnradio"
              id="btnradio6"
              autoComplete="off"
              onChange={handleFrec}
              checked={frec === "month"}
            />
            <label className="btn-frec" htmlFor="btnradio6">
              mes
            </label>
          </div>
        </div>)}

        {showTimeRange && (
          <div className="group row-timerange">
            <div className="label">
              <b>Horario</b>
            </div>

            <div className="ff-time-popover-wrapper">
              <TimeRangePopover
                mode="apply"
                hourFrom={hourFrom}
                hourTo={hourTo}
                onApply={(from, to) => onApplyTimeRange?.(from, to)}
                draftHourFrom={draftHourFrom}
                draftHourTo={draftHourTo}
                onDraftChange={(from, to) => onDraftTimeRange?.(from, to)}
              />
            </div>
          </div>
        )}
      </div>

      {(!isAnalysis && !isMaximeter)  &&
        <div className="row-refresh">
          <button className="btn-refresh" value={""} onClick={handleFrec}>
            <FormattedMessage id="Refresh" defaultMessage="Refresh" />
          </button>
        </div>
      }
    </div>
  );
};

export default FrequencyComponent;
